module.exports = __webpack_public_path__ + "4e6764d2b4489bb390bc580de6f45402.jpg";